export default {"src":"/oferta/_next/static/media/hypertrophy.02b27d24.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};